export const FeatureFlags = {
  BUY_NOW_PAY_LATER_V2: 'buyNowPayLaterV2',
};
